import { Resolver } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import { CandidatesHttpService } from '@core/services/http';

export class CandidatesMappingResolver implements Resolver {
  async resolve(): Promise<void> {
    await HttpService.getHttpRequests(CandidatesHttpService).getCandidates();
  }
}
